// Kundenverzeichnis: Personen, die eingecheckt haben oder Rechnungsdaten besitzen.
export const clientesDir = {
  title: "Kunden",
  subtitle: "Alle Personen, die eingecheckt haben oder Rechnungsdaten besitzen. Sie werden automatisch gespeichert und nie doppelt angelegt.",
  searchLabel: "Kunden suchen",
  searchPlaceholder: "Name, Dokument, E-Mail oder Telefon",
  filters: {
    todos: "Alle",
    checkin: "Mit Check-in",
    fiscal: "Mit Steuerdaten",
    reservas: "Mit Buchungen",
  },
  cols: {
    client: "Kunde",
    document: "Dokument",
    phone: "Telefon",
    stays: "Aufenthalte",
    lastStay: "Letzter Aufenthalt",
  },
  checkins: "{n} Check-in | {n} Check-ins",
  bookings: "{n} Buchung | {n} Buchungen",
  fiscalBadge: "Steuer",
  noDocument: "Kein Dokument",
  noName: "Ohne Namen",
  emptyTitle: "Noch keine Kunden",
  emptyText: "Alle, die einen Check-in abschließen, erscheinen hier automatisch.",
  emptySearch: "Kein Kunde entspricht „{q}“.",
  loadError: "Die Kunden konnten nicht geladen werden.",
  pageOf: "{from}–{to} von {total}",
  prev: "Zurück",
  next: "Weiter",
  docTypes: {
    P: "Reisepass",
    ID: "Nationaler Personalausweis",
    IM: "NIE",
    I: "Personalausweis",
    D: "Nationaler Personalausweis",
    N: "NIE",
    X: "Aufenthaltstitel",
    CC: "Staatsbürgerschaftskarte",
    CE: "Ausländerausweis",
    TI: "Identitätskarte",
    PPT: "PPT",
    PEP: "PEP",
  },
  sheet: {
    close: "Schließen",
    createBooking: "Buchung erstellen",
    personal: "Persönliche Daten",
    document: "Dokument",
    address: "Adresse",
    fiscal: "Steuerdaten",
    noFiscal: "Keine Steuerdaten. Sie werden beim Rechnungsstellen oder unter Rechnungen → Steuerkunden hinzugefügt.",
    defaultProfile: "Standard",
    bookings: "Buchungen",
    noBookings: "Keine verknüpften Buchungen.",
    companions: "Ist gereist mit",
    noCompanions: "Hat keine Buchung mit anderen Personen geteilt.",
    timesTogether: "{n} Mal | {n} Mal",
    invoices: "Rechnungen",
    noInvoices: "Keine Rechnungen.",
    viewPdf: "PDF ansehen",
    email: "E-Mail",
    phone: "Telefon",
    birthDate: "Geburtsdatum",
    sex: "Geschlecht",
    nationality: "Staatsangehörigkeit",
    docType: "Art",
    docNumber: "Nummer",
    expiry: "Ablaufdatum",
    support: "Supportnummer",
    street: "Adresse",
    zip: "Postleitzahl",
    city: "Stadt",
    country: "Wohnsitzland",
    roleCheckin: "Check-in",
    roleHolder: "Inhaber",
    loadError: "Die Kundenakte konnte nicht geöffnet werden.",
  },
  sexes: {
    M: "Männlich",
    F: "Weiblich",
  },
  picker: {
    missingPolice: "Für diesen Kunden sind in diesem Konto keine Meldedaten gespeichert. Trage sie jetzt ein, dann bleiben sie für das nächste Mal erhalten.",
    searchSaved: "Gespeicherten Kunden suchen",
    searchPlaceholder: "Name, Dokument oder Telefon…",
    noResults: "Kein gespeicherter Kunde gefunden.",
    selected: "Daten aus Kunden übernommen",
    clear: "Entfernen",
  },
  match: {
    title: "Dieser Kunde existiert bereits",
    text: "{name} ist bereits unter Kunden gespeichert. Sie können alle Daten mit einem Tipp übernehmen.",
    use: "Daten verwenden",
    dismiss: "Nicht diese Person",
    applied: "Daten von {name} übernommen. Prüfen Sie die Aufenthaltsdaten und unterschreiben Sie.",
    companionsTitle: "Früher gereist mit",
    companionsHint: "Tippen Sie auf eine Person, um sie mit ihren Daten zu registrieren.",
    registerCompanion: "{name} registrieren",
  },
};
